import './CustomSlider.scss';
import Slider from "react-slick";

export function CustomSlider ({src}) {
  
    const settings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    }

    return (
        <div className='custom-slider'>
          <Slider {...settings} className="slider_list">
            <div>
              <img src={src[0].src} loading="lazy" alt=""></img>
            </div>
            <div>
              <img src={src[1].src} loading="lazy" alt=""></img>
            </div>
            <div>
              <img src={src[2].src} loading="lazy" alt=""></img>
            </div>
            <div>
              <img src={src[3].src} loading="lazy" alt=""></img>
            </div>
          </Slider>
        </div>
    );
}